import Navbar from '../../components/feature/Navbar';
import Hero from './components/Hero';
import ToolFinderQuiz from './components/ToolFinderQuiz';
import FeaturedTools from './components/FeaturedTools';
import NewToolsThisWeek from './components/NewToolsThisWeek';
import Categories from './components/Categories';
import ToolsDirectory from './components/ToolsDirectory';
import WhyToolnova from './components/WhyToolnova';
import CTABanner from './components/CTABanner';
import EmailSignup from './components/EmailSignup';
import Footer from './components/Footer';
import XFollowWidget from '../../components/feature/XFollowWidget';
import { useSEO } from '../../hooks/useSEO';
import { Link } from 'react-router-dom';

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://toolnova.ai';

  useSEO({
    title: 'ToolNova - Discover the Best AI Tools for Work, Creativity & Business (2026)',
    description: 'Browse 100+ curated AI tools across 9 categories including Writing, Video, Image, Coding, and Marketing. Free to browse. Updated weekly.',
    keywords: 'AI tools, artificial intelligence, AI software, AI writing tools, AI image generators, AI video tools, productivity tools, business AI',
    canonical: `${siteUrl}/`,
    ogTitle: 'ToolNova - Discover the Best AI Tools for Work, Creativity & Business (2026)',
    ogDescription: 'Browse 100+ curated AI tools across 9 categories including Writing, Video, Image, Coding, and Marketing. Free to browse. Updated weekly.',
    ogType: 'website',
    ogUrl: `${siteUrl}/`,
    schema: [
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: 'ToolNova',
        url: 'https://toolnova.ai',
        description: 'Discover the best AI tools for everyday life. Browse 150+ curated AI tools by category.',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://toolnova.ai/search?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'ToolNova',
        url: 'https://toolnova.ai',
        logo: 'https://toolnova.ai/logo.png',
        description: 'ToolNova is a free AI tools discovery platform helping everyday people find the right AI tools for real life tasks.',
        founder: {
          '@type': 'Person',
          name: 'Reece Satran',
        },
        foundingDate: '2026',
        address: {
          '@type': 'PostalAddress',
          addressRegion: 'WA',
          addressCountry: 'US',
        },
        sameAs: [
          'https://x.com/toolnovaHQ',
        ],
      },
    ]
  });

  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      <Navbar />
      <Hero />
      <ToolFinderQuiz />
      <FeaturedTools />
      <NewToolsThisWeek />
      <Categories />
      <ToolsDirectory />
      <WhyToolnova />
      <CTABanner />
      {/* X Follow CTA */}
      <section className="px-6 py-8 max-w-4xl mx-auto w-full">
        <XFollowWidget variant="banner" />
      </section>
      <EmailSignup />
      <Footer />
    </div>
  );
}